export const getDocumentReferrer = (): string => {
    return document.referrer || 'NO_REFERRER';
};

/**
 * Retrieves a global AppConfig feature toggle from the window object. Used for toggles needed before the React application is initialized
 *
 * Does not work with dealer-specific toggles
 * @param name
 * @returns
 */
export const getGlobalFeatureToggle = (name: string): boolean | undefined => {
    return window.DealWorkflow?.toggles?.get(name);
};

/**
 * Retrieves a cookie value by name from document.cookie
 * @param name - The name of the cookie to retrieve
 * @returns The cookie value or null if not found
 */
export const getCookieValue = (name: string): string | null => {
    if (typeof document === 'undefined') {
        return null;
    }

    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
        const cookieValue = parts.pop()?.split(';').shift();
        return cookieValue || null;
    }

    return null;
};
